import { inject, Injectable } from '@angular/core';
import { TuiAlertService, TuiNotification } from '@taiga-ui/core';

@Injectable({
    providedIn: 'root'
})
export class MessageService {
    private readonly alertService = inject(TuiAlertService);

    constructor() {}

    info(message: string, label?: string) {
        return this.show(TuiNotification.Info, message, label);
    }

    warning(message: string, label?: string) {
        return this.show(TuiNotification.Warning, message, label);
    }

    success(message: string, label?: string) {
        return this.show(TuiNotification.Success, message, label);
    }

    error(message: string, label?: string) {
        return this.show(TuiNotification.Error, message, label);
    }

    show(status: TuiNotification, message: string, label?: string) {
        return this.alertService.open(message, { status, label }).subscribe();
    }
}
